import { ComponentPortal, ComponentType } from '@angular/cdk/portal';
import { ComponentRef, Injectable, Injector, inject } from '@angular/core';
import { Observable, filter, map } from 'rxjs';
import { SidenavLayout } from '../tokens/layout.token';

export interface SidenavRightPortalOptions {
  width?: string;
  injector?: Injector;
  hasBackdrop?: boolean;
  disableClose?: boolean;
}

@Injectable()
export class SidenavRightPortalService {
  private readonly _layout = inject(SidenavLayout);

  open<T>(component: ComponentType<T>, options: SidenavRightPortalOptions = {}): ComponentRef<T> {
    if (this._layout.outletRight.hasAttached()) {
      this._layout.outletRight.detach();
    }

    if (options.width) {
      this._layout.rightPanelWidth = options.width;
    }
    if (options.hasBackdrop !== undefined) {
      this._layout.hasBackdrop.set(options.hasBackdrop);
    }

    this._layout.sidenavRight.disableClose = options.disableClose ?? false;
    this._layout.sidenavRight.opened = true;

    const portal = new ComponentPortal(component, undefined, options.injector);
    return this._layout.outletRight.attach(portal);
  }

  close(): void {
    this._layout.sidenavRight.disableClose = false;
    this._layout.sidenavRight.opened = false;
    this._layout.hasBackdrop.set(false);
    if (this._layout.outletRight.hasAttached()) {
      this._layout.outletRight.detach();
    }
  }

  backdropClicked$(): Observable<void> {
    return this._layout.sidenavRight.backdropClicked.asObservable();
  }

  sidenavClosed$(): Observable<void> {
    return this._layout.sidenavRight.openedChange.pipe(
      filter((opened) => !opened),
      map(() => undefined)
    );
  }
}
